// @flow

/**
 * Module dependencies.
 */

import { branch } from 'core/utils/branch';
import { colors } from 'client/styles';
import { position, size } from 'polished';
import styled from 'styled-components';

/**
 * Export separator size.
 */

export const separatorSizes = {
  large: 90,
  medium: 60
};

/**
 * `Horizontal` separator component.
 */

const Horizontal = styled.div`
  ${position('absolute', 'calc(1em - 3px)', null, null, '0')}
  ${size('2px', '100%')}

  background-color: ${colors.brandPrimary};
  max-width: ${({ size }) => size || `${separatorSizes.medium}px`};

  ${({ styles }) => branch(styles, styles)}
`;

/**
 * `Vertical` separator component.
 */

const Vertical = styled.div`
  ${({ inline, size }) => branch(inline, `
    position: relative;
    height: ${size || `${separatorSizes.large}px`};

    &:after {
      position: absolute;
      top: 0;
      left: 50%;
      bottom: 0;

      background-color: ${colors.brandPrimary};
      content: '';
      display: block;
      transform: translateX(-50%);
      width: 2px;
    }
  `)}

  ${({ absolute, size }) => branch(absolute, `
    background-color: ${colors.brandPrimary};
    height: ${size || `${separatorSizes.large}px`};
    left: 0;
    position: absolute;
    top: calc(1em - 1px);
    width: 2px;
  `)}

  ${({ styles }) => branch(styles, styles)}
`;

/**
 * Export `Separator`.
 */

export const Separator = {
  Horizontal,
  Vertical
};



// WEBPACK FOOTER //
// ../src/client/components/separator/index.js